import React from 'react'
import { Input, Space, Spin, Typography } from 'antd'

const { Text } = Typography

const CardTitle = ({ isEditing, editName, handleEdit, titleValue, style = {}, extraFooter }) => {
  return (
    <Spin spinning={isEditing}>
      {editName ? (
        <Input
          autoFocus
          onClick={(e) => e.stopPropagation()}
          disabled={isEditing}
          defaultValue={titleValue}
          onBlur={(e) => handleEdit(e.target.value)}
          onPressEnter={(e) => handleEdit(e.target.value)}
        />
      ) : (
        <Space direction="horizontal">
          {extraFooter}
          <Text title={titleValue} style={style} ellipsis={true}>
            {titleValue}
          </Text>
        </Space>
      )}
    </Spin>
  )
}

export default CardTitle
